export default __webpack_public_path__ + "static/media/CRV-ETH.73986ed3.png";